export default "__VITE_ASSET__CwsUkGX7__"